// extracted by mini-css-extract-plugin
export var body = "_c3-0";
export var sectionHeader = "_c3-4";
export var shortcutColumns = "_c3-2";
export var shortcutList = "_c3-1";
export var shortcutSection = "_c3-3";